import compact from "lodash/compact";

const ICON_CHARACTER_WIDTH = 3;

type GetSmartMaxNameLengthParams = {
  maxNameLength: number;
  isCore?: boolean;
  isDevelopmental?: boolean;
  isVerified?: boolean;
  isVerifiedOthers?: boolean;
  hasTags?: boolean;
};

export const getPillIconsCount = ({
  isCore,
  isDevelopmental,
  isVerified,
  isVerifiedOthers,
  hasTags
}: Omit<GetSmartMaxNameLengthParams, "maxNameLength">) =>
  compact([isCore, isDevelopmental, isVerified || isVerifiedOthers, hasTags]).length;

export const getSmartMaxNameLength = ({
  maxNameLength,
  isCore,
  isDevelopmental,
  isVerified,
  isVerifiedOthers,
  hasTags
}: GetSmartMaxNameLengthParams): number => {
  const iconsCount = getPillIconsCount({ isCore, isDevelopmental, isVerified, isVerifiedOthers, hasTags });

  return maxNameLength - iconsCount * ICON_CHARACTER_WIDTH;
};
